import { GET_TABLE_DATA, SET_PAYMENT_DATA, CLEAR_PAYMENT_DATA } from './types'

const initialState = {
  data: {},
  paymentData: {},
  tableOptions: {},
}

export default function (state = initialState, action) {
  switch (action.type) {
    case CLEAR_PAYMENT_DATA:
      return {
        ...state,
        paymentData: {},
      }
    case GET_TABLE_DATA:
      return {
        ...state,
        data: action.payload.data,
        tableOptions: action.payload.options,
      }
    case SET_PAYMENT_DATA:
      return {
        ...state,
        paymentData: { ...state.paymentData, [action.payload.name]: action.payload.value },
      }
    default:
      return state
  }
}
